import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage {
  loading = false;
  error?: string;
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private userService: UserService,
    private router: Router
  ) {
    this.form = this.createForm();
    console.log('LoginPage initialized, form controls:', this.form.controls);
  }

  private createForm() {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.error = undefined;
    this.auth.login(this.form.value as any).subscribe({
      next: () => {
        this.userService.loadMe().subscribe();
        this.router.navigateByUrl('/app/home');
      },
      error: err => {
        this.error = err?.error?.message || 'Login failed';
        this.loading = false;
      }
    });
  }
}
